import { formatNumberWithCommas, formatNumberWithCommasAndDecimal } from "components/helpers"

export const REQUEST_COLUMN_WIDTH = {
    id: {
        width: '10%',
        isMobile: false
    },
    name: {
        width: '22%',
        isMobile: true
    },
    deposit: {
        width: '22%',
        isMobile: true
    },
    interest: {
        width: '10%',
        isMobile: false
    },
    claimed: {
        width: '20%',
        isMobile: false
    },
    available_w: {
        width: '25%',
        isMobile: false
    },
    mobile: {
        width: '50px',
        isMobile: true
    }
}

export const REQUEST_HEADERS = [
    {
        id: 'id',
        name: 'Number',
        cell: REQUEST_COLUMN_WIDTH.id,
    },
    {
        id: 'name',
        name: 'Name',
        cell: REQUEST_COLUMN_WIDTH.name,
    },
    {
        id: 'deposit',
        name: 'Deposit',
        cell: REQUEST_COLUMN_WIDTH.deposit,
    },
    {
        id: 'interest',
        name: 'Interest',
        cell: REQUEST_COLUMN_WIDTH.interest,
    },
    {
        id: 'claimed',
        name: 'Claimed',
        cell: REQUEST_COLUMN_WIDTH.claimed,
    },
    {
        id: 'available_w',
        name: 'Available for withdrawal',
        cell: REQUEST_COLUMN_WIDTH.available_w,
    },
    {
        id: 'mobile',
        name: 'Detailed',
        cell: REQUEST_COLUMN_WIDTH.mobile,
    },
]

export const REQUEST_ANALYTICS = [
    {
        id: '324324',
        name: 'Total value',
        number: formatNumberWithCommas('', 6597),
        description: 'Total value deposited',
        helpText: 'help text about Total value deposited',
    },
    {
        id: '324343424',
        name: 'Total outstanding',
        number: formatNumberWithCommasAndDecimal(197),
        description: 'Total outstanding interest',
        helpText: 'help text about Total outstanding interest'
    },
    {
        id: '324535324',
        name: 'Total earnings',
        number: formatNumberWithCommasAndDecimal(6597),
        description: 'Total earnings to date',
        helpText: 'help text about Total earnings to date'
    },
    {
        id: '3243535324',
        name: 'Number of patrons',
        number: '14',
        description: 'Number of patrons',
        helpText: 'help text about Number of patrons',
        isCurrency: false
    }]

export const REQUEST_MOCK_DATA = {
    headers: REQUEST_HEADERS,
    columnWidth: REQUEST_COLUMN_WIDTH,
    patrons: [{
        id: '758539',
        name: 'Aleksandr F',
        deposit: formatNumberWithCommas('USDC', 1500),
        interest: '2%',
        claimed: formatNumberWithCommasAndDecimal(1500, '$'),
        available_w: formatNumberWithCommasAndDecimal(1400, '$'),
        mobile: 'true'
    },
    {
        id: '758549',
        name: 'Ivanov F',
        deposit: formatNumberWithCommas('USDC', 1200),
        interest: '3%',
        claimed: formatNumberWithCommasAndDecimal(5400, '$'),
        available_w: formatNumberWithCommasAndDecimal(1200, '$'),
        mobile: 'true'
    },
    {
        id: '758399',
        name: 'Olegov D',
        deposit: formatNumberWithCommas('USDC', 800),
        interest: '4%',
        claimed: formatNumberWithCommasAndDecimal(500, '$'),
        available_w: formatNumberWithCommasAndDecimal(1000, '$'),
        mobile: 'true'
    },
    ]
}